import React from "react";
import { WordTitle, Pill, Reveal } from "./Reveal";
import ShaderBackground from "./ShaderBackground";

export default function PageHero({ label, title, text }) {
  return (
    <section className="relative overflow-hidden bg-[#f7f7f7] px-3 pb-3 pt-24 sm:px-5 sm:pb-5">
      <ShaderBackground strength={0.36} lines={11} fadeLeft={0.7} />
      <div className="relative z-10 mx-auto flex min-h-[62vh] max-w-[1400px] flex-col justify-end pb-6 sm:pb-10">
        <Pill white className="w-fit">{label}</Pill>
        <WordTitle
          text={title}
          className="mt-6 max-w-[1000px] text-[44px] leading-[0.98] sm:text-[72px] lg:text-[92px]"
        />
        {text && (
          <Reveal delay={600}>
            <p className="mt-8 max-w-[560px] text-[20px] leading-[1.25] tracking-[-0.02em] opacity-70 sm:text-[24px] sm:leading-[30px]">
              {text}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
